import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilitySwitch from "@/components/ui/VisibilitySwitch";
import { PANEL_TITLE_SX, PANEL_SUBTITLE_SX } from "@/theme/panelStyles";

export default function RnwPanelHeader({
  switchRnwAnalyserActive,
  onToggleVisibility,
  onClose,
  subtitle = "Route network diagnostics",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 1.5,
        flexShrink: 0,
      }}
    >
      <Box>
        <Typography sx={PANEL_TITLE_SX}>RNW Analyser</Typography>
        <Typography sx={PANEL_SUBTITLE_SX}>{subtitle}</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <VisibilitySwitch
          checked={switchRnwAnalyserActive}
          onChange={onToggleVisibility}
          slotProps={{ input: { "aria-label": "toggle RNW analyser visibility" } }}
        />
        <IconButton aria-label="close" onClick={onClose} sx={{ color: "#004f7d" }}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
